import { PrimaryDialog, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useActionPlanForm } from "./ActionPlanInitForm/useActionPlanForm";
import { ActionPlanInitForm } from "./ActionPlanInitForm/ActionPlanInitForm";
import { useSnackbar } from "src/utils/useSnackbar";
import { Loading } from "src/components/utils/Loading";
import { useActionsContext } from "src/context/Actions/useActionsContext";

export const ActionPlanUpsertModal = () => {
    const { t } = useTranslation();
    const { getElligibleStartingPosts } = useActionsContext();

    const elligibleStartingPosts = getElligibleStartingPosts();

    const snackbar = useSnackbar();
    const {
        actionPlan,
        scoresEnabled,
        createActionPlan,
        isOpenActionPlanForm: isOpen,
        setOpenActionPlanForm: setOpen,
    } = useActionsContext();

    const formHandler = useActionPlanForm({
        actionPlan,
        scoresEnabled,
        elligibleStartingPosts,
    });

    if (formHandler === undefined) return <Loading />;

    const { formState, setFormState, formSubmit, remainingScoreOptions, allScoreOptions } = formHandler;

    return (
        <PrimaryDialog
            open={isOpen}
            setOpen={setOpen}
            onValidate={() => {
                const data = formSubmit();

                snackbar.forceClose();
                snackbar.setSnackbarProps({
                    type: "info",
                    message: t("actionplan.creating"),
                    forceAutoHideInMilisecond: 10000,
                });

                if (data === null) return;
                createActionPlan(data);
            }}
            onCancel={() => {}}
            options={{
                title: <Typography variant="h4">{t("actionplan.trajectory.form.title")}</Typography>,
                content: (
                    <ActionPlanInitForm
                        form={formState}
                        setForm={setFormState}
                        closeModal={() => {
                            setOpen(false);
                        }}
                        remainingScoreOptions={remainingScoreOptions}
                        allScoreOptions={allScoreOptions}
                    />
                ),
            }}
            cancelText={t("primarydialog.cancel")}
            validateText={t("primarydialog.validate")}
        />
    );
};
